import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export const Hero = () => {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-stone-100" data-id="element-112">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-113">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-115">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-100 text-brand-800 text-sm font-medium mb-6" data-id="element-116">
              <span className="relative flex h-2 w-2" data-id="element-117">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-500 opacity-75" data-id="element-118"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-600" data-id="element-119"></span>
              </span>
              Nuevo recetario digital
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.15] text-stone-900 mb-6" data-id="element-120">
              ¿Y si el <span className="flash-word" data-id="element-121">cansancio</span>, los{' '}
              <span className="flash-word delay-1" data-id="element-122">kilitos de más</span>, la{' '}
              <span className="flash-word delay-2" data-id="element-123">caída de pelo</span> y la{' '}
              <span className="flash-word delay-3" data-id="element-124">piel seca</span> tuvieran una{' '}
              <span className="text-brand-700 italic" data-id="element-125">solución</span>, y es
              deliciosa?
            </h1>

            <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-126">
              Descubre <strong data-id="element-127">Plan Tiroides 360</strong>. Desayunos, almuerzos,
              cenas y postres diseñados para nutrir tu tiroides, recuperar tu
              energía y disfrutar comiendo sin restricciones extremas.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-128">
              <a href="#oferta" onClick={() => trackInitiateCheckout({
              currency: 'ARS',
              value: 17390,
              content_ids: ['plan-tiroides-360']
            })} className="inline-flex justify-center items-center px-8 py-4 text-lg font-semibold rounded-xl text-white bg-brand-700 hover:bg-brand-800 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-129">
                Quiero mis recetas ahora
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-sm text-stone-600 font-medium" data-id="element-130">
              <div className="flex items-center gap-1.5" data-id="element-131">
                <div className="flex text-amber-400" data-id="element-132">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-133" />)}
                </div>
                <span data-id="element-134">4.9/5 (240+ opiniones)</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-135">
                <ShieldCheckIcon className="w-5 h-5 text-brand-600" data-id="element-136" />
                <span data-id="element-137">Garantía de 7 Días</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:ml-10" data-id="element-138">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-100 to-brand-50 rounded-3xl transform rotate-3 scale-105 opacity-60" data-id="element-139"></div>
            <img src="https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BUNDLE_PLAN_TIROIDES.png?v=1779798823&width=900&quality=85&format=webp" srcSet="https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BUNDLE_PLAN_TIROIDES.png?v=1779798823&width=480&quality=80&format=webp 480w, https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BUNDLE_PLAN_TIROIDES.png?v=1779798823&width=900&quality=85&format=webp 900w" sizes="(max-width: 768px) 100vw, 50vw" alt="Plan Tiroides 360 — Bundle completo" width={900} height={900} loading="eager" fetchpriority="high" decoding="sync" className="relative object-contain h-[500px] w-full drop-shadow-2xl" data-id="element-140" />

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl flex items-center gap-4 animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-141">
              <div className="bg-brand-100 p-3 rounded-full text-brand-700" data-id="element-142">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-143">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-144" />
                </svg>
              </div>
              <div data-id="element-145">
                <p className="text-xs text-stone-500 font-medium" data-id="element-146">Incluye</p>
                <p className="text-sm font-bold text-stone-900" data-id="element-147">
                  +40 Recetas Fáciles
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};